import { FONT_FAMILY } from "../../ontego-ui";
import { Grid2, styled } from '@mui/material';

const Styled = {};

Styled.NoChartWrapper = styled(Grid2)(() => ({
    position: "absolute",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    borderRadius: 18
}));

Styled.NoChartContent = styled("span")(() => ({
    color: "white",
    textAlign: "center",
    marginTop: "20px",
    fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_SEMIBOLD,
    fontSize: "16px",
    fontWeight: 500
}));

Styled.NoChartContentSmall = styled("span")(() => ({
    color: "white",
    textAlign: "center",
    marginTop: "10px",
    fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_SEMIBOLD,
    fontSize: "12px",
}));

export default Styled;